<template>
	<div class="vue-wrapper">
        <User-Request-Filters
            :columns="Columns"
            :totals="$store.getters[storeModule+'/getTotals']"
            :activeList="activeList"
            :callOptionMethod="$store.getters[storeModule+'/getGrid'][this.activeList].statusLookup"
            v-on:update:filters="onFilterArgUpdate"
            v-on:submit:filters="onSubmitFilters"
            storeArgs="appUserRequestArgs"
            storeModule="appUserRequestList"
			storeFilter="appUserRequestFilters"
            ref="filterRef"
        />
    <b-container class="laneclosure-list organization-list-mobile organization-request-list-mobile wide">
        <slot>
            <div v-if="!$store.state.isMobile" class="column-grid lane-closure-table organization-table">
                <div class="row-wrap">
                    <div class="col-24 m24 xl24 t-header">
                        <div class="row-wrap heading">
                            <div class="col-24 gutter hide-on-med-and-down"
                                v-for="(column, index) in $store.getters[storeModule+'/getGrid'][activeList].columns"
                                :key="'index'+index"
                                :class="column.widths"
                            >
                                <caption class="column-title">
                                    <span v-text="column.alternateLabel ? column.alternateLabel : column.label" v-if="column.key != 'status'"></span>
                                    <b-form-select ref="filterIsActive" v-if="column.key == 'status'" :options="Organization.isActiveOptions" v-model="filterIsActive.value"
                                    @input="onFilterIsActive"
                                    :state="filterIsActive.status"
                                    value-field="id"
                                    text-field="name"
                                    class="filter-record-status-id"
                                    size="sm"
                                    >
                                    </b-form-select>

                                    <img src="@/assets/sort-desc.svg"
										class="ctrl-arrow"
										alt="downarrow"
										:data-key="column.sortable ? column.key : null"
										v-show="column.sortable && showSortArrow(column, 'desc')"
										@click="onColumnChevronToggle"
                                    />
                                    <img src="@/assets/sort-asc.svg"
                                        class="ctrl-arrow"
                                        alt="downarrow"
                                        :data-key="column.sortable ? column.key : null"
                                        v-show="column.sortable && showSortArrow(column, 'asc')"
                                        @click="onColumnChevronToggle"
                                        />
                                    <img src="@/assets/sort-none.svg"
                                        class="ctrl-arrow"
                                        alt="downarrow"
                                        :data-key="column.sortable ? column.key : null"
                                        v-show="column.sortable && showSortArrow(column, '')"
                                        @click="onColumnChevronToggle"
                                        />
                                </caption>
                            </div>
                        </div>
                        <div v-for="(row, index) in Records" :key="'ii'+index"
                            :class="`row-wrap records`"
                        >
                            <div class="col-24 xs24 l8 gutter ">
                                <br class="hide-on-large-and-up"/>
                                <div class="hide-on-med-and-down col-cta" @click="onRowSelected(index)">
                                    <span v-html="row.fullName"></span><br/>
                                    <span v-html="row.email"></span>
                                </div>
                                <span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="row.fullName"></span><br/>
                                <span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="row.email"></span>
                                <hr class="hide-on-large-and-up"/>
                            </div>
                            <div :class="getColumnClasses('organization', index)" @click="onRowSelected(index)">
                                <br class="hide-on-large-and-up"/>
                                <div class="hide-on-med-and-down col-cta">
                                    <span v-html="getFlatTree(row)"></span>
                                </div>
                                <span class="hide-on-large-and-up col-cta" v-html="getFlatTree(row)"></span>
                                <hr class="hide-on-large-and-up"/>
                            </div>
                            <div class="col-24 xs24 l4 gutter" @click="onRowSelected(index)">
                                <div class="hide-on-med-and-down col-cta">
                                <span v-html="getStatus(row)"></span>
                                </div>
                                <span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="getStatus(row)"></span>
                                <hr class="hide-on-large-and-up"/>
                            </div>

                            <div class="col-24 xs24 l4 gutter" @click="onRowSelected(index)">
                                <div class="hide-on-med-and-down col-cta">
                                <span v-html="getDateCreated(row)"></span>
                                </div>
                                <span class="hide-on-large-and-up col-cta" @click="onRowSelected(index)" v-html="getDateCreated(row)"></span>
                                <hr class="hide-on-large-and-up"/>
                            </div>
                            <div class="col-24 l24 list-spacer hide-on-med-and-down"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive organization-request-list-mobile" v-if="$store.state.isMobile">
                <table class="table table-stripped table-bordered">
                    <tr>
                        <th>REQUESTED USER</th>
                        <th>STATUS</th>
                    </tr>
                    <tr class="organization-request-list-wrapper"
                        v-for="(row, index) in Records" :key="'ii'+index"
                        @click="onRowSelected(index)"
                    >
                        <td class="organization">
                            <span v-html="row.fullName"></span><br/>
                            <span v-html="row.email"></span><br/>
                            <span v-html="row.organizationName"></span>
                        </td>
                        <td class="status">
                            <span v-html="getStatus(row)"></span>
                        </td>
                    </tr>
                </table>
            </div>
        </slot>
        <div class="paginateWrapper" v-show="!loading">
        <paginate
        :page-count="getPageCount"
        :page-range="3"
        :margin-pages="2"
        :click-handler="onPageClick"
        prev-text='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-left fa-w-10"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" class=""></path></svg>'
        next-text='<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg>'
        :container-class="'page-ctrl'"
        :page-class="'page'"
        :next-class="'page-next'"
        :prev-class="'page-prev'"
		ref="appUserRequestPaginator"
		v-model="page"
        >
        </paginate>
    	</div>
    </b-container>
    </div>
</template>

<script>
import AppUserRequestFilters from "./../../../components/AppUserRequestFilters.vue"
import BootstrapField from './../../../utility/BootstrapField';
import Spinner from "./../../../components/Spinner.vue"
import moment from 'moment'
import AppUserRequest from './../../../models/AppUserRequest.js'
import Organization from './../../../models/Organization.js'
import Format from './../../../utility/Format'


import Vue from 'vue'


export default {
    docTitle: "New Account Requests - Lane Closures",

    components: {
        'User-Request-Filters': AppUserRequestFilters,
        Spinner
    },
    mounted() {
        this.setEventBusOn();
		this.fetchData();
    },
    created() {
		// this.fetchData()
    },
    data() {
        return {
            AppUserRequest:AppUserRequest,
            showMap: false,
            activeList: 0,
            ascOrder: true,
            loading: true,
            page: 0,
            lastIndex: null,
            rowMapToggle:[],
            Records:[],
			currentPage:1,
            filterIsActive: new BootstrapField({
                value: null,
            }),
			filterApplied: false,
			storeModule:"appUserRequestList",
			storeArgs:"appUserRequestArgs",
        }
    },
    computed: {
        getPageCount() {
            let pageCount = 1;
            if (this.$store) {
				let pagination = this.$store.getters[this.storeModule+'/getPagination'];
                if (pagination) {
                    if (pagination.count) {
                        pageCount = Math.ceil(pagination.count / pagination.perPage);
                        if (pageCount < 1) {
                            pageCount = 1;
                        }

                    }
                }
            }
            return pageCount;
        },

		getPage() {
			let page = 1;
			if (this.$store) {
				let pagination = this.$store.getters[this.storeModule+'/getPagination'];
				if (pagination) {
					if (pagination.page >= 1) {
						return pagination.page;
					}
				}
			}
			return page;
		},
        Columns() {
			return this.$store.getters[this.storeModule+'/getGrid'][this.activeList].columns
		},
    },
    beforeDestroy() {
        this.setEventBusOff();
    },
    methods: {
        getFlatTree(entry) {
            if (entry.isNewPrimary) {
                return "<strong>" + entry.name + "</strong>" + " (NEW ORGANIZATION REQUESTED)";
            } else {
                if (entry.organizationNamePath) {
                    return Format.pipesToFlatTree(entry.organizationNamePath);
                } else {
                    return entry.name;
                }
            }
        },
        getDateCreated(entry) {
            return moment(entry.createdDate).format('MMMM D, Y H:mm:ss');
        },
        getColumnClasses(key, index) {
		let classes =  "col-24 xs24 l8 gutter hide-on-med-and-down col-cta";
          classes += " value-" + key;
          if (key == "name") {
            classes += " level-" + this.Records[index].level;
          }
          return classes;
        },
		friendlyDateFromNow(dt) {
			return Format.diffYMDHMSAgo(dt, new Date);
		},
        setEventBusOff() {
            this.$bus.$off('update:pages', this.onPagePagination);

        },
        setEventBusOn() {
            this.setEventBusOff();
            this.$bus.$on('update:pages', this.onPagePagination);

        },
        onPageClick(value) {
            this.page = value
			this.$store.dispatch(this.storeModule+'/updateParams', { page: value } )
            this.fetchData()
        },
        onFilterIsActive() {
        this.$store.dispatch(this.storeModule+'/updateParams', { isActive: this.filterIsActive.value} )
        this.fetchData()
    },
        onSubmitFilters() {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
            if (argQuery) {
                this.onFilterArgUpdate(argQuery)
            }
            this.$store.dispatch(this.storeModule+'/updateParams', { page: 1} )

            this.fetchData()
        },
        forceArgUpdate() {
            let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
            if (argQuery) {
                this.onFilterArgUpdate(argQuery)
            }
            this.fetchData()
        },
        onFilterArgUpdate(queryArg) {
            this.$store.dispatch(this.storeModule+'/updateParams', { page: 1 } );
            this.$store.dispatch(this.storeModule+'/updateParams', queryArg )
        },
        onPagePagination(value) {
            this.page = value
            this.$store.dispatch(this.storeModule+'/updatePagination', { page: value } )
        },
        fetchData() {
            document.getElementById('main').scrollTo(0,0)

            this.loading = true
            this.$store.dispatch(this.storeModule+'/load', this.$store.getters[this.storeModule+'/getParams'])
                .then(() => {
                    this.loading = false;
                        this.Records = [];
                        let records = this.$store.getters[this.storeModule+'/getRecords'];
                        this.$store.getters[this.storeModule+'/getGrid'][this.activeList].statusLookup;
                        if ( records ) {
                            records.forEach( item => {
                                this.Records.push(item);
                            })

                        }
                        // console.log(this.Records);

                    })
                .catch( error => console.log('error', error) )
        },
        onRowSelected(index) {
            this.$router.push({name:"EditAppUserRequest", params:{id: this.Records[index].id}});
		},


        getStatus(entry) {
            let txt = "";

            // we only care if the organization is not approved...
            let approvalStatus = Format.searchByKeyInArray(entry.isApproved, 'value', AppUserRequest.getIsApprovedOptions);
            if (approvalStatus) {
                if (txt != "") txt += ", ";
                txt += approvalStatus.text;
            } else {
                if (txt != "") txt += ", ";
                txt += "Not Processed";
            }
            return txt;
        },
        onColumnChevronToggle(e, toggle = null) {
            e.preventDefault()
            if ( e.target.getAttribute('data-key') ) {
                // if ( this.$store.getters[this.storeModule+'/getParams'].sortBy !== e.target.getAttribute('data-key') ) {
                //     this.$store.dispatch(this.storeModule+'/updateParams', { sortBy: e.target.getAttribute('data-key') } )
                // }
                // this.ascOrder = !this.ascOrder
                // this.ascOrder ? e.target.classList.add('asort') : e.target.classList.remove('asort')
                // this.$store.dispatch(this.storeModule+'/updateParams', { sortOrder: this.ascOrder ? 'asc' : 'desc' } )
                // this.fetchData()

                var dbKey = e.target.getAttribute('data-key');

				if (this.$store.getters[this.storeModule+'/getParams'].sortBy !== dbKey) {
					this.$store.dispatch(this.storeModule+'/updateParams', { sortBy: dbKey, sortOrder: 'asc' });
				} else {
					this.$store.dispatch(this.storeModule+'/updateParams', { sortOrder: this.$store.getters[this.storeModule+'/getParams'].sortOrder == 'asc' ? 'desc' : 'asc' });
				}
				this.$refs.filterRef.changeSortFromColumn(dbKey, this.$store.getters[this.storeModule+'/getParams'].sortOrder);

            } else {
                Vue.prototype.$bus.$emit("map:toggle", e, toggle)
            }
        },
        showSortArrow(column, order) {
			let sortBy = this.$store.getters[this.storeModule+"/getParams"].sortBy;
			let sortOrder = this.$store.getters[this.storeModule+"/getParams"].sortOrder;

			var dbKey = column.key;

			if (order == '' || order == null) {
				return dbKey != sortBy
			} else {
				return dbKey == sortBy && sortOrder == order
			}

		},
        parseOwner(item) {
            let owner = item.owner ? `${item.owner.firstName} ${item.owner.lastName}<sup class="e-owner"></sup><br class="hide-on-med-and-down"/>` : '',
                requester = item.requester ? `${item.requester.firstName} ${item.requester.lastName}<sup class="e-requester"></sup><br class="hide-on-med-and-down"/>` : '',
                alternate = item.alternate ? `${item.alternate.firstName} ${item.alternate.lastName}<sup class="e-alternate"></sup><br class="hide-on-med-and-down"/>` : ''
            owner += owner && requester ? '<span class="hide-on-large-and-up"> / </span>'+requester : requester
            owner += owner && alternate ? '<span class="hide-on-large-and-up"> / </span>'+alternate : alternate
            return owner
        },
        parseLocation(loc1, loc2, loc3) {
            let location = loc1 ? loc1 : ' '
            location = location && loc2 ? `${location}, ${loc2 ? loc2 : ' '}` : location
            location = location && loc3 ? `${location} to ${loc3 ? loc3 : ' '}` : location
            return location
        },
        strReplace(string, searchValue, newValue) {
            if (typeof string === 'string') {
                return string.replace(searchValue, newValue)
            }
            return string
        }
    },
	beforeRouteEnter(to, from, next) {
	next(vm => {
	Vue.prototype.$bus.$emit("map:clear", 1);
	Vue.prototype.$bus.$emit("map:toggle", 0);
	});
	},

    beforeRouteLeave(to, from, next) {
        Vue.prototype.$bus.$emit("map:clear", 1);
        next(true);
    },

}
</script>
